<template>
    <div class="parallax-container">
        <div class="parallax">
            <img :src="require('@/assets/parallax1.jpg')">
        </div>
    </div>
</template>